<!-- Mobile Navigation Item -->
<mat-list-item class="mobile-nav-item" [class.active]="isActive(item)" [class.disabled]="item.disabled"
    [class.has-children]="item.children && item.children.length > 0" [class.child-item]="level > 0"
    (click)="onItemClick(item, $event)">

    @if (item.icon) {
    <mat-icon matListItemIcon class="mobile-nav-icon">{{ item.icon }}</mat-icon>
    }

    <div class="mobile-label-container" matListItemTitle>
        <span class="mobile-item-label">
            {{ item.label }}
        </span>

        <!-- Badge for mobile -->
        @if (item.badge) {
        <span class="mobile-item-badge">
            {{ item.badge }}
        </span>
        }

        <!-- Expand/Collapse icon for parent items with children -->
        @if (item.children && item.children.length > 0) {
        <mat-icon class="mobile-expand-icon" [class.expanded]="item.expanded">
            {{ item.expanded ? 'expand_less' : 'expand_more' }}
        </mat-icon>
        }
    </div>
</mat-list-item>

<!-- Recursive Children for mobile -->
@if (item.children && item.children.length > 0 && item.expanded) {
<div class="mobile-child-items-container">
    @for (child of item.children; track child.id) {
    <lib-vertical-menu-mobile-item [item]="child" [isCollapsed]="isCollapsed" [level]="level + 1"
        [isHandset]="isHandset">
    </lib-vertical-menu-mobile-item>
    }
</div>
}